export default "__VITE_ASSET__8999d210__"